import React, { useEffect, useState } from "react";
import Modal from "../../Components/Kanban/Modal/Modal";
import styled from "styled-components";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import { useDispatch, useSelector } from "react-redux";
import filterSign from "../../Images/filterSign.svg";
import { useSession } from "../../authentications/SessionContext";
import { companyAction } from "../../Redux/Reducers/CompanySlice";
import { PAGINATION_DEFAULT_LIMIT } from "../../utilities/constants";
import { FaSearch } from "react-icons/fa";
import { unLink } from "../../DataApi/unlink";
import { useLocation } from "react-router-dom";
import { searchReadCompany } from "../../DataApi/Company/searchReadCompany";
// import cameraIcon from "../../Images/camera.svg";
// import NewUserForm from "../../Components/UsersComponent/NewUserForm";
import AddNewCompany from "../../Components/CompanyComponents/AddNewCompany";
import useConfirmationModal from "../../Components/ConfirmationModal/useConfirmationModal";
import ActionButton from "../../Components/Buttons/ActionButton";
import { TableContainer } from "../../Components/StyledComponents/TableContainer/TableContainer";
import LoaderWrapper from "../../Components/Loader/LoaderWrapper";
import TableLoader from "../../Components/Loaders/TableLoader";
import {
  COMPANY_LIST_TABLE_VIEW,
  VTEX_MERCHANT_COMPANY_LIST_TABLE_VIEW,
} from "../../utilities/tables-view-constants";
import { VTEX_COMPANY_LIST_TABLE_VIEW } from "../../utilities/tables-view-constants";
import TableBody from "../../Components/Table/TableBody";
import TableHeader from "../../Components/Table/TableHeader";
import Pagination from "../../Components/Table/TableFooter/Pagination";
import TableToolbar from "../../Components/Table/TableToolbar";
import ReactSelect from "react-select";

const companyFilterListOptions = [
  {
    label: "Pending Companies",
    value: JSON.stringify(["vtex_status", "=", "pending"]),
  },
  { label: "Companies", value: "" },
];
const CompanySortListOptions = [
  { label: "Default", value: "create_date" },
  { label: "Name", value: "name" },
  { label: "Partner", value: "partner_id" },
];

const UsersFirstSection = styled.div`
  justify-content: space-between;
  padding: 10px;
  .Filter_icon_div {
    width: 50px;
    height: 47px !important;
    border-radius: 30% !important;
    background-color: #f8f9fa !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  .btn_and_icons {
    display: flex;
    justify-content: center;
  }
  .dropdown-item {
    text-align: center;
    color: #000000;
  }
  .dropdown_list_div {
    background-color: #f8f9fa;
    height: 45px;
    color: #b0b7c3;
    font-size: 14px;
    font-family: "Inter";
    border-radius: 14px;
    border: none;
    background-color: #f8f9fa;
    padding: 6px;
    border: none;
    margin-left: 10px;
  }
  .dropdown_list_div select {
    padding: 4px 14px;
    background-color: transparent;
    border: 0;
    color: #000000;
    font-size: 16px;
    width: auto;
    font-family: "Inter";
    &:focus {
      border: none;
      outline: none;
    } /* Adjust the line height to create space between options */
  }

  option {
    font-size: 16px;
    line-height: 6;
    padding: 12px !important;
    font-family: "Inter";
    margin: 10px !important;
  }
  .sort_by {
    margin-top: 6px;
    margin-right: 10px;
    font-size: 16px;
  }
  .Filter_icon_div img {
    transition: transform 0.3s ease;
  }
  .show_text {
    margin-top: 18px;
  }
`;
const NewButton = styled.button`
  border-radius: 15px;
  background-color: #ff5837;
  color: #ffffff;
  border: none;
  width: 130px;
  min-width: 125px;
  height: 40px;
  margin-right: 10px;
`;
const ProductsContainer = styled.div`
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 2rem;
  margin: 30px;
  border-radius: 20px;
`;
const SearchDiv = styled.form`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  background-color: #f8f9fa;
  family-font: "Inter";

  input[type="text"] {
    width: 100%;
    padding: 10px;
    padding-left: 40px;
    border-radius: 5px;
    border: none;
    font-size: 16px;
    margin-right: 10px;
    background-color: #f8f9fa;
    &:focus {
      border: none;
      outline: none;
    }
  }

  .search-container {
    position: relative;
    width: 100%;
  }
`;
const SearchIcon = styled.span`
  position: absolute; /* Position the icon absolutely */
  top: 50%;
  left: 2px;
  transform: translateY(-50%);
  color: #b0b7c3;
  cursor: pointer;
  padding: 12px;
`;

const Company = () => {
  const { sessionInfo } = useSession();
  const {
    company_id,
    context,
    user_companies,
    isVTEX,
    is_vtex_admin,
    is_vtex_omantal,
    is_admin,
    is_merchant,
  } = sessionInfo;
  const { companyList, length, loading } = useSelector(
    (state) => state.company
  );
  const [searchQuery, setSearchQuery] = useState("");

  const dispatch = useDispatch();
  const [UsersSort, setUsersSort] = useState(CompanySortListOptions[0].value);
  const { ConfirmationModal, toggleModal, setMetaData, setTitle } =
    useConfirmationModal();
  const [filterDirection, setFilterDirection] = useState("desc");
  const { language, translations } = useLanguage();
  const t = translations[language];
  const [selectedRows, setSelectedRows] = useState([]);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(PAGINATION_DEFAULT_LIMIT);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isListLoading, setIsListLoading] = useState(false);
  const [companyTypeFilter, setCompanyTypeFilter] = useState(
    companyFilterListOptions[1]
  );
  const location = useLocation();

  // Access the state object passed from the previous component
  const stateData = location?.state;
  const shouldCompanyModalOpen = stateData ? stateData.openCompanyModal : false;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const handleRowClick = (record) => {
    setIsCreateModalOpen(true);
    setSelectedRecord(record);
  };
  const handleChangePage = (value) => {
    setCurrentPage(value);
  };
  const handleCreateClick = () => {
    setIsCreateModalOpen(true);
  };
  const handleCloseModal = () => {
    setSelectedRecord(null);
    setIsCreateModalOpen(false);

    // setSelectedRecord({});
    // setIsDetailsModalOpen(false);
  };

  const handleDeleteOrder = async () => {
    let response = await unLink({
      id: selectedRows,
      company_id,
      context,
      model: "res.company",
    });
    response = JSON.parse(response);
    if (response?.result) {
      setSelectedRows([]);
      refetchData();
    } else {
      // console.log("unlink error response", response?.error?.data?.message);
      toggleModal();
      setTitle("Validation Error");
      setMetaData({
        primaryButton: "",
        secondaryButton: "Ok",
        dangerouslySetInnerHTML: response?.error?.data?.message,
      });
    }
  };
  const handleEditList = (record) => {
    setIsCreateModalOpen(true);
    setSelectedRecord({ id: record });
  };
  const toggleSelectAll = () => {
    if (selectedRows.length === companyList.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(companyList.map((record) => record.id));
    }
  };
  const handleChangeCompanyTypeFilter = (value, e) => {
    setCompanyTypeFilter(value);
  };
  const handleChangeUsersSortDirection = () => {
    setFilterDirection(filterDirection === "asc" ? "desc" : "asc");
  };
  const handlechangeUsersSorting = (e) => {
    setUsersSort(e.target.value);
  };

  const refetchData = () => {
    dispatch(
      companyAction.fetchCompanyData({
        context,
        company_id,
        pagination: {
          offset: (currentPage - 1) * itemsPerPage,
          limit: itemsPerPage,
        },
        search: {
          query:
            is_merchant && !is_vtex_admin && !is_vtex_omantal
              ? user_companies?.current_company?.[1]
              : searchQuery,
          type: companyTypeFilter?.value || "",
        },

        sort: {
          type: UsersSort || "",
          dir: filterDirection,
        },
      })
    );
  };
  const getMyCompany = async () => {
    // console.log("user_companies", user_companies);
    let response = await searchReadCompany({
      context,
      company_id,
      pagination: { limit: 1, offset: 0 },
      search: {
        query: user_companies?.current_company?.[1],
        type: "",
      },
      sort: { type: "", dir: "asc" },
    });
    response = JSON.parse(response) || {};
    // console.log(response, "response");
    handleRowClick(response?.result?.records[0]);
  };

  useEffect(() => {
    refetchData();
  }, [currentPage, searchQuery, UsersSort, filterDirection, companyTypeFilter]);
  useEffect(() => {
    if (shouldCompanyModalOpen) {
      getMyCompany();
    } else {
      handleCloseModal();
    }
  }, [shouldCompanyModalOpen]);

  const toggleSelectRow = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };
  return (
    <>
      <ConfirmationModal />
      <UsersFirstSection className="d-flex justify-content-end w-100 orders-first-section">
        <div className="d-flex product_filter_div me-2">
          <ReactSelect
            value={companyTypeFilter}
            options={companyFilterListOptions}
            name="type"
            onChange={handleChangeCompanyTypeFilter}
            styles={{
              control: (provided) => ({
                ...provided,
                minHeight: "45px !important",
                color: "#b0b7c3",
                fontSize: "14px",
                fontFamily: "Inter",
                borderRadius: "14px",
                border: "none",
                backgroundColor: "#f8f9fa",
                padding: "6px",
                boxShadow: "none",
              }),
            }}
          />
        </div>
        <div className="btn_and_icons">
          {/* <NewButton onClick={handleCreateClick}>+ {t["Add new"]}</NewButton> */}
          {isCreateModalOpen && (
            <Modal isOpen={isCreateModalOpen} onClose={handleCloseModal}>
              <AddNewCompany
                selectedRecord={selectedRecord}
                handleCloseModal={() => {
                  setSelectedRows([]);
                  handleCloseModal();
                  refetchData();
                }}
              />
            </Modal>
          )}
          <div className="Filter_icon_div">
            <img
              src={filterSign}
              alt="filter"
              style={{
                transform: `rotate(${
                  filterDirection === "asc" ? "180" : "0"
                }deg)`,
              }}
              onClick={handleChangeUsersSortDirection}
            />
          </div>

          <div className="dropdown_list_div d-flex">
            <p className="sort_by">Sort by:</p>
            <select
              className="custom-select"
              onChange={handlechangeUsersSorting}
              value={UsersSort}
              name="type"
            >
              {CompanySortListOptions.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </UsersFirstSection>
      <ProductsContainer>
        <TableContainer data-isvtex={isVTEX}>
          <TableToolbar
            handleDelete={handleDeleteOrder}
            handleEditList={handleEditList}
            setSearchQuery={setSearchQuery}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
          />
          <table className="table">
            <TableHeader
              tableHeaderList={
                isVTEX
                  ? is_vtex_admin
                    ? VTEX_COMPANY_LIST_TABLE_VIEW
                    : VTEX_MERCHANT_COMPANY_LIST_TABLE_VIEW
                  : COMPANY_LIST_TABLE_VIEW
              }
            />
            <TableBody
              tableData={companyList}
              handleRowClick={handleRowClick}
              tableBodyList={
                isVTEX
                  ? is_vtex_admin
                    ? VTEX_COMPANY_LIST_TABLE_VIEW
                    : VTEX_MERCHANT_COMPANY_LIST_TABLE_VIEW
                  : COMPANY_LIST_TABLE_VIEW
              }
              isLoadingData={loading === "pending" || loading === "idle"}
              checkIsLoadingData
            />
          </table>
          <Pagination
            ListViewData={companyList}
            indexOfFirstItem={indexOfFirstItem}
            indexOfLastItem={indexOfLastItem}
            currentPage={currentPage}
            handleChangePage={handleChangePage}
            PAGINATION_DEFAULT_LIMIT={itemsPerPage}
            totalDataLength={length}
          />
        </TableContainer>
      </ProductsContainer>
    </>
  );
};

export default Company;
